export default __webpack_public_path__ + "static/media/icon-ux-feedback.326d9000.svg";